import SearchForm from "../forms/SearchForm";

function SearchPage() {
    return(
        <SearchForm />
    )
}

export default SearchPage;